import { render, staticRenderFns } from "./ListaTicketsUser.vue?vue&type=template&id=50aa4543"
import script from "./ListaTicketsUser.vue?vue&type=script&lang=js"
export * from "./ListaTicketsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports